jQuery(function($) {
    console.log('[DEBUG] logos-block.js loaded');
    console.log('[DEBUG] jQuery.fn.slick available:', typeof $.fn.slick);
    console.log('[DEBUG] Logo sliders found:', $('.col-logos.logo-slick-5plus:not(.hero-logo-slider)').length);
    
    // Regular logos block (exclude hero sliders)
    $('.col-logos.logo-slick-5plus:not(.hero-logo-slider)').slick({
        arrows: true,
        centerMode: true,
        infinite: true,
        slidesToShow: 5,
        prevArrow:'<button type="button" class="slick-prev"><span class="icon material-symbols-outlined">west</span></button>',
        nextArrow:'<button type="button" class="slick-next"><span class="icon material-symbols-outlined">east</span></button>',
        responsive: [
            {
              breakpoint: 1390,
              settings: {
                slidesToShow: 4,
                infinite: true,
              }
            },
            {
                breakpoint: 1160,
                settings: {
                  slidesToShow: 3,
                  infinite: true,
                }
            },
            {
                breakpoint: 940,
                settings: {
                  slidesToShow: 2,
                  infinite: true,
                }
            },
            {
                breakpoint: 735,
                settings: {
                  slidesToShow: 1,
                  infinite: true,
                }
            },
        ]
    });

    $('.col-logos.logo-slick-5:not(.hero-logo-slider)').slick({
        arrows: true,
        centerMode: true,
        infinite: true,
        slidesToShow: 4,
        prevArrow:'<button type="button" class="slick-prev"><span class="icon material-symbols-outlined">west</span></button>',
        nextArrow:'<button type="button" class="slick-next"><span class="icon material-symbols-outlined">east</span></button>',
        responsive: [
            {
                breakpoint: 1160,
                settings: {
                  slidesToShow: 3,
                  infinite: true,
                }
            },
            {
                breakpoint: 940,
                settings: {
                  slidesToShow: 2,
                  infinite: true,
                }
            },
            {
                breakpoint: 735,
                settings: {
                  slidesToShow: 1,
                  infinite: true,
                }
            },
        ]
    });

    $('.col-logos.logo-slick-4:not(.hero-logo-slider)').slick({
        arrows: true,
        centerMode: true,
        infinite: true,
        slidesToShow: 3,
        prevArrow:'<button type="button" class="slick-prev"><span class="icon material-symbols-outlined">west</span></button>',
        nextArrow:'<button type="button" class="slick-next"><span class="icon material-symbols-outlined">east</span></button>',
        responsive: [
            {
                breakpoint: 940,
                settings: {
                  slidesToShow: 2,
                  infinite: true,
                }
            },
            {
                breakpoint: 735,
                settings: {
                  slidesToShow: 1,
                  infinite: true,
                }
            },
        ]
    });

    $('.col-logos.logo-slick-3:not(.hero-logo-slider)').slick({
        arrows: true,
        centerMode: true,
        infinite: true,
        slidesToShow: 2,
        prevArrow:'<button type="button" class="slick-prev"><span class="icon material-symbols-outlined">west</span></button>',
        nextArrow:'<button type="button" class="slick-next"><span class="icon material-symbols-outlined">east</span></button>',
        responsive: [
            {
                breakpoint: 735,
                settings: {
                  slidesToShow: 1,
                  infinite: true,
                }
            },
        ]
    });

    $('.col-logos.logo-slick-2:not(.hero-logo-slider)').slick({
        arrows: true,
        centerMode: true,
        infinite: true,
        slidesToShow: 1,
        prevArrow:'<button type="button" class="slick-prev"><span class="icon material-symbols-outlined">west</span></button>',
        nextArrow:'<button type="button" class="slick-next"><span class="icon material-symbols-outlined">east</span></button>',
        responsive: [
            {
                breakpoint: 735,
                settings: {
                  slidesToShow: 1,
                  infinite: true,
                }
            },
        ]
    });

    // Hero Logo Slider - Different responsive settings for 75% width container
    $('.hero-logo-slider.logo-slick-5plus').slick({
        arrows: true,
        centerMode: false,
        infinite: true,
        slidesToShow: 3,
        centerPadding: '0px',
        prevArrow:'<button type="button" class="slick-prev"><span class="icon material-symbols-outlined">west</span></button>',
        nextArrow:'<button type="button" class="slick-next"><span class="icon material-symbols-outlined">east</span></button>',
        responsive: [
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 3,
                centerPadding: '0px',
                infinite: true,
              }
            },
            {
                breakpoint: 940,
                settings: {
                  slidesToShow: 2,
                  centerPadding: '0px',
                  infinite: true,
                }
            },
            {
                breakpoint: 735,
                settings: {
                  slidesToShow: 1,
                  centerPadding: '0px',
                  infinite: true,
                }
            },
        ]
    });

    $('.hero-logo-slider.logo-slick-5').slick({
        arrows: true,
        centerMode: true,
        infinite: true,
        slidesToShow: 3,
        centerPadding: '0px',
        prevArrow:'<button type="button" class="slick-prev"><span class="icon material-symbols-outlined">west</span></button>',
        nextArrow:'<button type="button" class="slick-next"><span class="icon material-symbols-outlined">east</span></button>',
        responsive: [
            {
                breakpoint: 940,
                settings: {
                  slidesToShow: 2,
                  centerPadding: '0px',
                  infinite: true,
                }
            },
            {
                breakpoint: 735,
                settings: {
                  slidesToShow: 1,
                  centerPadding: '0px',
                  infinite: true,
                }
            },
        ]
    });

    $('.hero-logo-slider.logo-slick-4').slick({
        arrows: true,
        centerMode: true,
        infinite: true,
        slidesToShow: 3,
        centerPadding: '0px',
        prevArrow:'<button type="button" class="slick-prev"><span class="icon material-symbols-outlined">west</span></button>',
        nextArrow:'<button type="button" class="slick-next"><span class="icon material-symbols-outlined">east</span></button>',
        responsive: [
            {
                breakpoint: 940,
                settings: {
                  slidesToShow: 2,
                  centerPadding: '0px',
                  infinite: true,
                }
            },
            {
                breakpoint: 735,
                settings: {
                  slidesToShow: 1,
                  centerPadding: '0px',
                  infinite: true,
                }
            },
        ]
    });

    $('.hero-logo-slider.logo-slick-3').slick({
        arrows: true,
        centerMode: true,
        infinite: true,
        slidesToShow: 2,
        centerPadding: '0px',
        prevArrow:'<button type="button" class="slick-prev"><span class="icon material-symbols-outlined">west</span></button>',
        nextArrow:'<button type="button" class="slick-next"><span class="icon material-symbols-outlined">east</span></button>',
        responsive: [
            {
                breakpoint: 735,
                settings: {
                  slidesToShow: 1,
                  centerPadding: '0px',
                  infinite: true,
                }
            },
        ]
    });

    $('.hero-logo-slider.logo-slick-2').slick({
        arrows: true,
        centerMode: true,
        infinite: true,
        slidesToShow: 1,
        centerPadding: '0px',
        prevArrow:'<button type="button" class="slick-prev"><span class="icon material-symbols-outlined">west</span></button>',
        nextArrow:'<button type="button" class="slick-next"><span class="icon material-symbols-outlined">east</span></button>',
        responsive: [
            {
                breakpoint: 735,
                settings: {
                  slidesToShow: 1,
                  centerPadding: '0px',
                  infinite: true,
                }
            },
        ]
    });
});